<template>
    <div>
        <Head :title="__(title)" />
<!--        <div class="mb-6 flex justify-between items-center">-->
<!--            <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input>-->
<!--        </div>-->
        <div class="bg-white rounded-md shadow overflow-hidden mr-2">
            <form @submit.prevent="filter">
                <div class=" flex flex-wrap">
                    <div class="w-full mx-auto">
                        <div class="pt-3 pl-6 border-b border-gray-200 dark:border-gray-700 tab-head">
                            <ul class="flex flex-wrap -mb-px" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
                                <li class="mr-2" role="presentation" v-for="(tab, ti) in tabs" :key="ti">
                                    <div v-if="ti !== 2" class="inline-block text-gray-500 hover:text-gray-600 hover:border-gray-300 rounded-t-lg py-4 px-4 text-sm text-center border-transparent border-b-2 dark:text-gray-400 dark:hover:text-gray-300" :class="{'active': filters['period'] === tab.period }" @click="activeTab(ti)">{{ tab.name }}</div>
                                    <Datepicker calendar-class-name="schedule__picker" v-if="ti === 2" v-model="rangeDate" range multi-calendars :month-change-on-scroll="false" :enable-time-picker="false" ref="dateOverride" month-name-format="long" auto-apply keep-action-row :close-on-auto-apply="false" model-type="yyyy-MM-dd">
                                        <template #trigger>
                                            <div class="override__btn clickable-text inline-block text-gray-500 hover:text-gray-600 hover:border-gray-300 rounded-t-lg py-4 px-4 text-sm text-center border-transparent border-b-2 dark:text-gray-400 dark:hover:text-gray-300" :class="{'active': filters['period'] === 'range' }">{{ tab.name }}</div>
                                        </template>
                                        <template #action-select>
                                            <div class="flex cancel__apply w-full gap-4 p-6" v-if="rangeDate">
                                                <div class="flex __btn" @click="closeOverrideCalendar">Cancel</div>
                                                <div class="flex __btn" @click="selectRange">Apply</div>
                                            </div>
                                        </template>
                                    </Datepicker>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content">
                            <div class=" t-content active">
                                <div class="flex flex-col w-full">
                                    <div v-if="Object.keys(event_dates).length" class="flex flex-col w-full" v-for="(ed_value, ed_key) in event_dates" :key="ed_key">
                                        <div class="p-4 flex e__date border-t bg-gray">{{ moment(ed_key, 'YYYY-MM-DD').format('dddd, MMMM D, YYYY') }} <span v-if="moment().isSame(ed_key, 'day')" class="today">TODAY</span></div>
                                        <div class="flex flex-col event__item bg-white border-t w-full" v-for="event_date in ed_value">
                                            <div class="px-4 py-5 flex gap-3 cursor-pointer select-none w-full" @click="event_date.have_details = !event_date.have_details">
                                                <div class="flex">
                                                    <div class="w-5 h-5 rounded-full color" :style="{'background-color': event_date.color}"></div>
                                                </div>
                                                <div class="flex " :class="{'line-through':!event_date.is_active}">
                                                    {{ event_date.start }} - {{ event_date.end }}
                                                </div>
                                                <div class="flex flex-col pl-0 md:pl-8 gap-3" :class="{'line-through':!event_date.is_active}">
                                                    <div class="name">{{ event_date.name }}</div>
                                                    <div class="type">Event Type: <strong>{{ event_date.event_type.name }}</strong></div>
                                                </div>
                                                <div class="flex ml-auto">
                                                    <div class="flex gap-3 details">
                                                        <icon :name="event_date.have_details?'up':'down'" class="w-4 h-4 opacity-50" />
                                                        Details
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="px-4 py-5 flex gap-3 w-full bg-white" v-if="event_date.have_details">
                                                <div class="flex flex-col gap-3 md:pr-6">
                                                    <Link :href="this.route('event.reschedule', event_date.uid)" class="btn btn-indigo flex gap-3" type="button"> <icon name="repeat" class="fill-white w-4" /> Reschedule</Link>
                                                    <button class="btn btn-indigo flex gap-3" type="button" @click="cancelEvent(event_date.id)"> <icon name="trash" class="fill-white w-4" /> Cancel</button>
                                                    <Link :href="this.route('event_types.edit', event_date.event_type.id)" class="flex gap-2 pt-3 border-t"><icon name="edit" class="h-4 h-4" /> Edit Event Type</Link>
                                                </div>
                                                <div class="flex gap-2 flex-col">
                                                    <div class="flex font-bold uppercase">Email</div>
                                                    <div class="flex">{{ event_date.email }}</div>

                                                    <div class="flex font-bold uppercase pt-5">Invitee Time Zone</div>
                                                    <div class="flex">{{ event_date.timezone }}</div>

                                                    <div class="flex font-bold uppercase pt-5">Questions</div>
                                                    <p class="flex opacity-50">Please share anything that will help prepare for our meeting.</p>
                                                    <div class="flex">{{ event_date.question }}</div>

                                                    <p class="flex opacity-50 pt-5">Created {{ moment(event_date.created_at).format('D MMMM YYYY') }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="flex flex-col w-full p-5"><p>{{ __('No event found!') }}</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">

                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import { Link, Head } from '@inertiajs/inertia-vue3'
import moment_timezone from 'moment-timezone'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import {ref} from 'vue'

export default {
    metaInfo: { title: 'FAQs' },
    components: {
        Icon,
        Pagination,
        SearchInput,
        Link,
        Head,
        Datepicker,
    },
    layout: Layout,
    props: {
        filters: Object,
        events: Object,
        title: String,
    },
    remember: 'form',
    setup() {
        let dateOverride = ref(null);
        const closeOverrideCalendar = () => {
            if (!!dateOverride.value && dateOverride.value.length) {
                dateOverride.value[0].closeMenu()
            }
        }
        return {
            dateOverride,
            closeOverrideCalendar
        }
    },
    data() {
        return {
            tabs:[
                {'name': 'Upcoming', 'active': true, 'period' : 'upcoming'},
                {'name': 'Past', 'active': false, 'period': 'past'},
                {'name': 'Date Range', 'active': false, 'period': 'range'},
                {'name': 'Canceled', 'active': false, 'period': 'canceled'},
            ],
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
                period: this.filters.period,
                range: this.filters.period === 'range' ? this.filters.range : null,
            },
            event_dates: {},
            rangeDate: null
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('schedules.list'), pickBy(this.form), { replace: true, preserveState: false })
            }, 150),
        },
    },
    methods: {
        cancelEvent(id){
            if (confirm('Are you sure you want to delete this event?')) {
                this.axios.post(this.route('schedule.cancel', id), []).then((response) => {
                    console.log('done!')
                    this.crossEvent(id)
                }).catch((error) => {
                    console.log(error)
                })
            }
        },
        crossEvent(id){
            const findCrossEventIndex = this.events.data.findIndex(e=> e.id = id)
            console.log(findCrossEventIndex)
            this.events.data[findCrossEventIndex].is_active = false
        },
        selectRange(){
            this.form.range = {start: this.rangeDate[0], end: this.rangeDate[1]}
            this.form.period = 'range'
        },
        activeTab(index){
            for (const tab_item of this.tabs) {
                tab_item.active = false
            }
            if(this.tabs[index].period === 'range'){

            }else{
                this.form.period = this.tabs[index].period
            }
        },
        filter(){

        },
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        pushEventData(event_item){
            if(typeof this.event_dates[event_item.date] === 'object'){
                this.event_dates[event_item.date].push(event_item)
            }else{
                this.event_dates[event_item.date] = [].concat(event_item)
            }
        },
        processData(){
            this.event_dates = {}
            for (const event_item of this.events.data) {
                let period = this.filters['period']??'upcoming'
                const start = this.moment(event_item.date+' '+event_item.start, 'YYYY-MM-DD h:mma').tz(event_item.timezone, true)
                if(period === 'upcoming'){
                    if(this.moment().isBefore(start)){
                        this.pushEventData(event_item)
                    }
                }else if(period === 'past'){
                    if(this.moment().isAfter(start)){
                        this.pushEventData(event_item)
                    }
                }else{
                    this.pushEventData(event_item)
                }
            }
        }
    },
    mounted() {
        this.processData()
    },
    created() {
        this.moment = moment_timezone
        if(!this.filters['period']){
            this.filters['period'] = 'upcoming'
        }
    }
}
</script>
